var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M43 0H20.9749V22H43V0ZM41.0471 11C41.0471 14.6587 38.8414 17.9577 35.4576 19.3592C32.0724 20.7613 28.175 19.9882 25.583 17.4005C22.991 14.8128 22.215 10.9201 23.617 7.53803C25.019 4.15595 28.3228 1.95065 31.9875 1.95065C36.9899 1.95319 41.0446 6.00323 41.0471 11ZM17.9693 7.42744C16.5224 3.94065 13.1148 1.66815 9.33601 1.67001C4.18093 1.67255 0.00254361 5.84618 2.28481e-06 10.9954C-0.00186055 14.7699 2.27322 18.1736 5.76399 19.6189C9.25476 21.0642 13.2734 20.2662 15.9454 17.5973C18.6174 14.9283 19.4163 10.9142 17.9693 7.42744Z","fill":"currentColor"}));
}

Logo.defaultProps = {"width":"43","height":"22","viewBox":"0 0 43 22","fill":"none"};

module.exports = Logo;

Logo.default = Logo;
